import { useEffect, useRef, useState } from "react";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import grapesjsPresetNewsletter from "grapesjs-preset-newsletter";
import grapesjsBlocksBasic from "grapesjs-blocks-basic";

function WebBuilder({ onInit, initialData }) {
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const [isEditorReady, setIsEditorReady] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    
    // Small delay to ensure DOM is fully ready
    const timer = setTimeout(() => {
      try {
        const editor = grapesjs.init({
          container: containerRef.current,
          height: "700px",
          width: "100%",
          storageManager: false,
          plugins: [grapesjsPresetNewsletter, grapesjsBlocksBasic],
          pluginsOpts: {
            [grapesjsPresetNewsletter]: {
            },
            [grapesjsBlocksBasic]: {
              blocks: ['text', 'image', 'video', 'map'],
            }
          },
          avoidInlineStyle: false,
          clearOnRender: true,
          forceClass: false,
          components: '',
          style: '',
        });

        editorRef.current = editor;
        
        if (onInit) {
          onInit(editor);
        }

        const forceVideoControls = () => {
          try {
            const wrapper = editor.getWrapper();
            if (!wrapper) return;
            
            const videos = wrapper.find('video');
            let modified = false;
            
            videos.forEach(video => {
              const attrs = video.getAttributes();
              if (!attrs.controls && attrs.controls !== false) {
                video.setAttributes({ ...attrs, controls: true });
                modified = true;
              }
            });
            
            if (modified) {
              setTimeout(() => {
                editor.refresh();
              }, 50);
            }
          } catch (err) {
            console.warn("Error forcing video controls:", err);
          }
        };

        const forceDomControls = () => {
          setTimeout(() => {
            try {
              const canvas = editor.Canvas;
              if (canvas && canvas.getFrameEl) {
                const iframe = canvas.getFrameEl();
                if (iframe && iframe.contentDocument) {
                  const videos = iframe.contentDocument.querySelectorAll('video');
                  videos.forEach(video => {
                    if (!video.controls) {
                      video.controls = true;
                    }
                  });
                }
              }
            } catch (err) {
              console.warn("Error forcing DOM controls:", err);
            }
          }, 200);
        };

        editor.on('load', () => {
          setIsEditorReady(true);

          if (initialData && typeof initialData === 'object') {
            setTimeout(() => {
              try {
                editor.loadProjectData(initialData);
                setTimeout(() => {
                  forceVideoControls();
                  forceDomControls();
                }, 150);
              } catch (error) {
                console.error("Error loading initial data:", error);
              }
            }, 100);
          } else {
            setTimeout(() => {
              forceVideoControls();
              forceDomControls();
            }, 100);
          }
        });

        editor.on('component:update', (component) => {
          if (component.get('type') === 'video') {
            setTimeout(() => {
              const attrs = component.getAttributes();
              if (!attrs.controls) {
                component.setAttributes({ ...attrs, controls: true });
              }
              forceDomControls();
            }, 50);
          }
        });

        editor.on('error', (error) => {
          console.warn('GrapesJS error:', error);
        });

        setTimeout(() => {
          if (editorRef.current) {
            forceDomControls();
          }
        }, 1000);

      } catch (error) {
        console.error("Failed to initialize GrapesJS:", error);
      }
    }, 50);

    return () => {
      clearTimeout(timer);
      if (editorRef.current) {
        try {
          editorRef.current.destroy();
        } catch(e) {
          console.warn("Error destroying editor:", e);
        }
        editorRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} />;
}

export default WebBuilder;